const types = {
  LOGIN: "LOGIN",

  LOGOUT: "LOGOUT",
};

export default types;
